// @flow
import * as React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Row, Col, Button, Form } from 'react-bootstrap';
import { CSSTransitionGroup } from 'react-transition-group';
import Input from '../../components/Input';
import { FirstChild } from '../../helpers';

import { noValidate } from '../../helpers';

type Props = {
  isSaving: boolean,
  settings: Object,
  successMsg: string,
  errorMsg: string,
  handleSubmit: (v: Object) => void
};

const SettingsHelpLinksForm = (props: Props) => (
  <Form onSubmit={props.handleSubmit}>
    <h2>Global</h2>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Industries Landing Page Help PDF URL"
          placeholder={
            props.settings && props.settings.industryHelpPdf
              ? props.settings.industryHelpPdf.description
              : ''
          }
          name="industryHelpPdf.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Industries Landing Page Help Video URL"
          placeholder={
            props.settings && props.settings.industryHelpVideo
              ? props.settings.industryHelpVideo.description
              : ''
          }
          name="industryHelpVideo.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Insight Sets Landing Page Help PDF URL"
          placeholder={
            props.settings && props.settings.insightSetHelpPdf
              ? props.settings.insightSetHelpPdf.description
              : ''
          }
          name="insightSetHelpPdf.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Insight Sets Landing Page Help Video URL"
          placeholder={
            props.settings && props.settings.insightSetHelpVideo
              ? props.settings.insightSetHelpVideo.description
              : ''
          }
          name="insightSetHelpVideo.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>

    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Customers Landing Page Help PDF URL"
          placeholder={
            props.settings && props.settings.customerHelpPdf
              ? props.settings.customerHelpPdf.description
              : ''
          }
          name="customerHelpPdf.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Customers Landing Page Help Video URL"
          placeholder={
            props.settings && props.settings.customerHelpVideo
              ? props.settings.customerHelpVideo.description
              : ''
          }
          name="customerHelpVideo.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>

    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Users Landing Page Help PDF URL"
          placeholder={
            props.settings && props.settings.globalUserHelpPdf
              ? props.settings.globalUserHelpPdf.description
              : ''
          }
          name="globalUserHelpPdf.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Users Landing Page Help Video URL"
          placeholder={
            props.settings && props.settings.globalUserHelpVideo
              ? props.settings.globalUserHelpVideo.description
              : ''
          }
          name="globalUserHelpVideo.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>

    <h2>Customers</h2>

    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Campaigns Landing Page Help PDF URL"
          placeholder={
            props.settings && props.settings.campaignHelpPdf
              ? props.settings.campaignHelpPdf.description
              : ''
          }
          name="campaignHelpPdf.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Campaigns Landing Page Help Video URL"
          placeholder={
            props.settings && props.settings.campaignHelpVideo
              ? props.settings.campaignHelpVideo.description
              : ''
          }
          name="campaignHelpVideo.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Map Where Tab Help PDF URL"
          placeholder={
            props.settings && props.settings.mapWhereHelpPdf
              ? props.settings.mapWhereHelpPdf.description
              : ''
          }
          name="mapWhereHelpPdf.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Map Where Tab Help Video URL"
          placeholder={
            props.settings && props.settings.mapWhereHelpVideo
              ? props.settings.mapWhereHelpVideo.description
              : ''
          }
          name="mapWhereHelpVideo.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Map Who Tab Help PDF URL"
          placeholder={
            props.settings && props.settings.mapWhoHelpPdf
              ? props.settings.mapWhoHelpPdf.description
              : ''
          }
          name="mapWhoHelpPdf.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Map Who Tab Help Video URL"
          placeholder={
            props.settings && props.settings.mapWhoHelpVideo
              ? props.settings.mapWhoHelpVideo.description
              : ''
          }
          name="mapWhoHelpVideo.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>

    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Catchment Sets Landing Page Help PDF URL"
          placeholder={
            props.settings && props.settings.catchmentSetHelpPdf
              ? props.settings.catchmentSetHelpPdf.description
              : ''
          }
          name="catchmentSetHelpPdf.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Catchment Sets Landing Page Help Video URL"
          placeholder={
            props.settings && props.settings.catchmentSetHelpVideo
              ? props.settings.catchmentSetHelpVideo.description
              : ''
          }
          name="catchmentSetHelpVideo.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>

    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Users Landing Page Help PDF URL"
          placeholder={
            props.settings && props.settings.userHelpPdf
              ? props.settings.userHelpPdf.description
              : ''
          }
          name="userHelpPdf.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Users Landing Page Help Video URL"
          placeholder={
            props.settings && props.settings.userHelpVideo
              ? props.settings.userHelpVideo.description
              : ''
          }
          name="userHelpVideo.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>

    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Customer Detail Page Help PDF URL"
          placeholder={
            props.settings && props.settings.customerDetailHelpPdf
              ? props.settings.customerDetailHelpPdf.description
              : ''
          }
          name="customerDetailHelpPdf.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Customer Detail Page Help Video URL"
          placeholder={
            props.settings && props.settings.customerDetailHelpVideo
              ? props.settings.customerDetailHelpVideo.description
              : ''
          }
          name="customerDetailHelpVideo.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>

    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Sub Account Detail Page Help PDF URL"
          placeholder={
            props.settings && props.settings.subAccountDetailHelpPdf
              ? props.settings.subAccountDetailHelpPdf.description
              : ''
          }
          name="subAccountDetailHelpPdf.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12} className="form-input">
        <Field
          component={Input}
          type="text"
          label="Sub Account Detail Page Help Video URL"
          placeholder={
            props.settings && props.settings.subAccountDetailHelpVideo
              ? props.settings.subAccountDetailHelpVideo.description
              : ''
          }
          name="subAccountDetailHelpVideo.value"
          validate={[noValidate]}
        />
      </Col>
    </Row>
    <Row>
      <Col sm={12}>
        <Button
          bsStyle="primary"
          type="submit"
          className="relative-padding"
          disabled={props.isSaving}
        >
          {props.isSaving ? 'Saving...' : 'Save'}
        </Button>
      </Col>
    </Row>
    <br />
    <Row>
      <Col sm={12}>
        <CSSTransitionGroup
          component={FirstChild}
          transitionName="fade"
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          {props.successMsg ? (
            <p key="success" className="text-success">
              {props.successMsg}
            </p>
          ) : null}
        </CSSTransitionGroup>
      </Col>
    </Row>
    {props.errorMsg && (
      <div className="alert alert-danger">{props.errorMsg}</div>
    )}
  </Form>
);

export default reduxForm({
  form: 'settingsHelpLinksForm'
})(SettingsHelpLinksForm);



// WEBPACK FOOTER //
// ./src/containers/settings/SettingsHelpLinksForm.js